module.exports = __webpack_public_path__ + "37c09332f4bd38f73d534b4b078952f2.svg";